<script>
	export let event = () => {};
	export let row = {};
	export let key = "";
	export let action = "";
	export let options = [];
	export let format = "";
	export let className = "";
	export let label = "";
	export let index = -1;

	let icons = {
		edit: "/assets/icon-pen.svg",
		view: "/assets/icon-eye.svg",
	};
</script>

<button
	type="button"
	class="action-icon"
	style="background:none;border:none;padding:0;cursor:pointer;"
	on:click={() => event(row.id, row.caseOrigin, row.status)}
>
	<img src={icons[action]} alt="action-icon" />
</button>

<style>
	.action-icon:hover {
		cursor: pointer;
	}
</style>
